import type { ReadonlyDeep } from 'type-fest';

import { SectionTemplateInput } from '@e-socna/data-layer';

import { codingConfigForm2ApiMapper } from '../../../forms/CodingConfig/mappers/coding-config.form2api.mapper';
import { pruneInput } from '../../../utils/prune-input.util';
import { recursiveSectionForm2ApiMapper } from '../../../components/DocumentEditor/mappers/recursive-section.form2api.mapper';

import type { SectionTemplatePage_OneSectionTemplate } from '../../SectionTemplate/hooks/useFindOneSectionTemplateQuery.hook';

export function sectionTemplateForm2ApiMapper(
  sectionTemplate: ReadonlyDeep<SectionTemplatePage_OneSectionTemplate>,
) {
  const sectionTemplateInput = pruneInput(
    sectionTemplate,
    SectionTemplateInput,
  );

  return {
    ...sectionTemplateInput,
    virtualRoot: recursiveSectionForm2ApiMapper(sectionTemplate.virtualRoot),
    codingConfig: codingConfigForm2ApiMapper(sectionTemplate.codingConfig),
  };
}
